/*
INTELLECTUAL PROPERTY NOTICE
© Orbit Tickets Ltd. All rights reserved.
This file contains Custom / Included Intellectual Property created for and owned by the Customer as part of an application developed by Kaleida within the Platform.
Custom / Included Intellectual Property may be used, reproduced, adapted, and incorporated into any application, system, or product developed by or on behalf of the Customer, whether or not such application forms part of the Platform, subject always to the terms of the agreement and provided that such use does not include or rely upon any Protected Intellectual Property of Kaleida Ltd.
For the avoidance of doubt, the inclusion of any application within the Platform does not restrict the Customer's right to use Custom / Included Intellectual Property outside of the Platform.
*/

// IP-NOTICE: CUSTOM
export enum DesignFont {
	F37AnalogBold = 1,
	Manrope = 2,
	OpenSans = 3,
	Exo = 4,
	Arial = 5,
	Oswald = 6,
	Comfortaa = 7,
	RobotoSlab = 8,
	TimesNewRoman = 9,
	Lora = 10,
	PlayfairDisplay = 11,
	Kalam = 12,
	Amita = 13,
	Oregano = 14,
	LifeSavers = 15,
	Lobster = 16,
}
